import React, {ChangeEvent, useEffect, useState} from 'react'
import {ICandidateVacancyStepItem} from '../../types/candidate/ICandidateVacancyStepItem'
import {Button, Modal} from 'react-bootstrap'
import vacansyService from '../../api/vacancy.api'
import {socket} from '../../App'
import {useStores} from '../../stores'
import {ICandidateShort} from '../../types/candidate/ICandidateShort'
import {IDictionaryItem} from '../../types/IDictionaryItem'
import dictionaryService from '../../api/dictionary.api'
import {toast} from "react-toastify";
import userService from "../../api/user.api";
import {IUserShort} from "../../types/user/IUserShort";
import moment from "moment";
import {FORMAT_DATE_BASE} from "../../helpers/convertUTCToDatestring";
import {getErrorMessage} from "../../helpers/errorMessage";

type Props = {
  step: ICandidateVacancyStepItem,
  candidate: ICandidateShort,
  vacancyId: number
  update: () => void
}

const ChangeMeetingDateModal = (props: Props) => {
  const [show, setShow] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [usersSelect, setUsersSelect] = useState<IUserShort[]>([]);
  const [usersSelected, setUsersSelected] = useState<string[]>([]);
  const handleClose = () => setShow(false);
  const { authStore } = useStores();
  const vacancyCompanyId = authStore.user?.vacancyCompany || null

  const handleShow = async () => {
    setShow(true);
    try {
      const {data} = await userService.findByRoles(['hiring', 'hrmanager'])
      setUsersSelect(data)
    } catch (e) {
      console.error(e)
    }
    dictionaryService.findAll("meetingType", vacancyCompanyId).then(response => {
      setMeetingTypes(response.data)
    }).catch(e => console.log(e))
  }
  const [meetingTypes, setMeetingTypes] = useState<IDictionaryItem[]>([])
  const [meetingTypeId, setMeetingTypeId] = useState<number>(0)


  const localDate = new Date(props.step.meetingDate);
  const offsetTimezone = localDate.getTimezoneOffset() * 60000;
  const localDateWithOffset = new Date(localDate.getTime() - offsetTimezone);

  const [meetingDate, setMeetingDate] = useState<string>(props.step.meetingDate ? localDateWithOffset.toISOString().slice(0, 16) : "")

  const handleForm = () => {
    const selectedEmail = usersSelected || [authStore.user?.email]
    vacansyService.changeMeetingDate(props.step.id, moment(meetingDate).unix(), meetingTypeId, vacancyCompanyId, selectedEmail)
      .then(response => {
        socket.emit('chat message', JSON.stringify({
          email: authStore.user?.email,
          action: `Этап "${props.step.step.name}" с ${props.candidate.firstName} ${props.candidate.lastName} ${!props.step.meetingDate ? "назначен" : "перенесен"} на ${meetingDate}`,
          link: '/vacancy-candidates/' + props.vacancyId,
          type: 'meeting-date',
          users: selectedEmail,
          vacancyCompanyId
        }));
        toast.success('Дата и время встречи успешно изменено.');

        props.update();
        handleClose();
      })
      .catch(error => {
        const message = getErrorMessage(error, "Не удалось изменить дату встречи. Попробуйте снова.")

        toast.error(message);
      });
  }

  const deleteEvent = async () => {
    try {
      const res = await vacansyService.deleteMeetingDate(props.step.id, meetingTypeId)
      toast.success(`Собеседование, запланированное на ${moment(props.step.meetingDate).format(FORMAT_DATE_BASE)} удалено`);
      props.update();
      setIsDelete(false);
      handleClose();
    } catch (error: any) {
      const message = error?.response?.data === 'NOT_FOUND'
        ? "Не удалось найти событие"
        : `Не удалось удалить дату встречи. Попробуйте снова. Ошибка: ${error?.response?.data}`

      toast.error(message);
    }
  }

  const handleSelectUser = (e: ChangeEvent<HTMLSelectElement>) => {
    const selectedUsers = Array.from(e.target.selectedOptions, option => option.value);

    setUsersSelected(prev => [...prev, ...selectedUsers.filter(user => !prev.includes(user))]);
  };

  const handleRemoveUser = (email: string) => {
    setUsersSelected(prev => prev.filter(user => user !== email));
  };

  useEffect(() => {
    setUsersSelected(props.step?.attendees?.map(item => item.email) || [])

  }, [usersSelect]);

  return <>
    <Button variant="primary" onClick={handleShow}>
      {
        !props.step.meetingDate ? "Назначить" : "Перенести"
      }
    </Button>
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Перенос даты</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isDelete
          ? <>
            <p
              className='text-danger'>{`Вы действительно хотите удалить Собеседование, запланированное на "${moment(props.step.meetingDate).format(FORMAT_DATE_BASE)}"?`}</p>
            <div className={'flex gap-4 mt-2'}>
              <Button onClick={() => setIsDelete(false)}>Отменить</Button>
              <Button onClick={deleteEvent} variant='danger'>Удалить</Button>
            </div>
          </>
          : <>
            <p>На какую дату хотите перенести "{props.step.step.name}"?</p>
            <input type="datetime-local" className="form-control mb-2"
                   value={meetingDate} onChange={(e) => setMeetingDate(e.target.value)}
            />
            <select className='form-select mb-3'
                    value={meetingTypeId} onChange={((e) => setMeetingTypeId(parseInt(e.target.value)))}
            >
              <option value=''>-Выберите формат-</option>
              {
                meetingTypes.map((type) => (
                  <option value={type.id} key={type.id}>{type.name}</option>
                ))
              }
            </select>

            <select
              className='form-select mb-3'
              value={usersSelected}
              onChange={handleSelectUser}
            >
              <option value=''>-Выберите пользователя-</option>
              {usersSelect
                .filter(user => !usersSelected.includes(user.email))
                .map(user => (
                  <option value={user.email} key={user.id}>
                    {`${user.firstName} ${user.secondName}`}
                  </option>
                ))}
            </select>

            <div className="selected-users my-2 p-3 bg-gray-100 rounded-lg shadow-sm max-h-[350px] overflow-y-auto">
              <p className="text-lg font-medium mb-2">Выбранные пользователи:</p>
              {usersSelected.length === 0 ? (
                <p className="text-gray-500 text-sm">Нет выбранных пользователей.</p>
              ) : (
                <ul className="space-y-2">
                  {usersSelected.map((email) => {
                    const user = usersSelect.find(u => u.email === email);
                    return (
                      <li key={email}
                          className="flex items-center justify-between p-2 bg-white rounded-md shadow-sm hover:bg-gray-200">
            <span className="text-sm text-gray-800">
              {user ? `${user.firstName} ${user.secondName}` : email}
            </span>
                        <button
                          onClick={() => handleRemoveUser(email)}
                          className="text-red-500 hover:text-red-700 focus:outline-none">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24"
                               stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                  d="M6 18L18 6M6 6l12 12"/>
                          </svg>
                        </button>
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>

            <div className={'flex gap-4 justify-between'}>
              <Button onClick={handleForm}>Сохранить изменения</Button>
              <Button disabled={!props.step.meetingDate} onClick={() => setIsDelete(true)}>Удалить</Button>
            </div>
          </>
        }
      </Modal.Body>
    </Modal>
  </>
}

export default ChangeMeetingDateModal